// extracted by mini-css-extract-plugin
export default {"order":"Order_order__dI5lu","oderInner":"Order_oderInner__v56Wr","OrderSuccess":"Order_OrderSuccess__gCgch","pedido":"Order_pedido__fvsxv","pedDetail":"Order_pedDetail__V17GS"};